module.exports = __webpack_public_path__ + "img/07.16908f4b.png";